module.exports = __webpack_public_path__ + "img/baidu.ab5aa140.png";